import React from 'react';
import { Alert } from 'react-bootstrap';
import { InfoOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';

interface ScopeIndicatorProps {
  resource: string;
}

const ScopeIndicator: React.FC<ScopeIndicatorProps> = ({ resource }) => {
  const { getScope } = useAuth();
  const { t } = useTranslation('common');
  
  if (getScope(resource) !== 'assigned') {
    return null;
  }

  return (
    <Alert
      variant="info"
      className="mb-3 d-inline-flex align-items-center gap-2 an-scope-indicator"
      style={{
        width: 'fit-content',
        maxWidth: '100%',
        padding: '0.5rem 0.75rem',
        color: 'var(--an-text-secondary)',
        background: 'linear-gradient(135deg, var(--an-info-light), var(--an-surface))',
        border: '1px solid rgb(var(--an-info-rgb) / 0.18)',
        borderRadius: 'var(--an-radius-sm)',
        boxShadow: 'none',
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 24,
          height: 24,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          color: 'var(--an-info)',
          background: 'var(--an-info-light)',
          borderRadius: 'var(--an-radius-sm)',
        }}
      >
        <InfoOutlined fontSize="small" />
      </span>
      <small
        className="fw-semibold"
        style={{
          color: 'var(--an-text-secondary)',
          lineHeight: 1.35,
        }}
      >
        {t('messages.scopeIndicator')}
      </small>
    </Alert>
  );
};

export default ScopeIndicator;
